

// handle formvalue

// Define the formValues object
var formValues = {
  foot_length: "22.7 cm",
  foot_width: "7.5 cm",
  sneaker_size: "",
  instep_size: "",
  arch_size: "",
  hallux: "",
  shoe_type: "",
};

// Inline step feedback: replaces blocking alert() popups.
function showStepError(msg) {
  var visibleStep = document.querySelector('.step:not([style*="display: none"]):not([style*="display:none"])');
  if (!visibleStep) { alert(msg); return; }
  var box = visibleStep.querySelector('.fit-step-error');
  if (!box) {
    box = document.createElement('div');
    box.className = 'fit-step-error';
    box.setAttribute('role', 'alert');
    var btn = visibleStep.querySelector('.nextStepButton');
    if (btn && btn.parentNode) { btn.parentNode.insertBefore(box, btn); }
    else { visibleStep.appendChild(box); }
  }
  box.textContent = msg;
  box.style.display = 'block';
}
function clearStepErrors() {
  document.querySelectorAll('.fit-step-error').forEach(function (el) { el.style.display = 'none'; });
}



// Measurement sliders: slider + numeric input + cm/inch toggle, kept in sync.
// The slider and formValues always work in cm (the API expects cm); the number
// field, tooltip and scale render in the active unit.

document.addEventListener('DOMContentLoaded', () => {
  const cmToIn = (v) => Math.round((v / 2.54) * 100) / 100;
  const inToCm = (v) => Math.round(v * 2.54 * 10) / 10;

  let unit = localStorage.getItem('fit_unit')
    || document.getElementById('fit_default_unit')?.value
    || 'cm';
  if (unit !== 'in') unit = 'cm';

  const measures = [
    {
      slider: '#singleSlider', tooltip: '#singleSliderTooltip', scale: '#scale',
      num: '#lengthNum', formKey: 'foot_length',
      ticks: [22.7, 24.4, 26.1, 27.8, 29.5, 31.2, 33],
    },
    {
      slider: '#singleSlider2', tooltip: '#singleSliderTooltip2', scale: '#scale2',
      num: '#widthNum', formKey: 'foot_width',
      ticks: [7.5, 8.3, 9.1, 9.9, 10.7, 11.5, 12.3, 13.1, 13.8],
    },
  ].map((m) => ({
    ...m,
    sliderEl: document.querySelector(m.slider),
    tooltipEl: document.querySelector(m.tooltip),
    scaleEl: document.querySelector(m.scale),
    numEl: document.querySelector(m.num),
  })).filter((m) => m.sliderEl);

  function displayVal(cm) {
    return unit === 'in' ? cmToIn(cm) : Math.round(cm * 10) / 10;
  }

  function setTooltip(m) {
    const cm = parseFloat(m.sliderEl.value);
    const min = parseFloat(m.sliderEl.min);
    const max = parseFloat(m.sliderEl.max);
    const pos = (cm - min) / (max - min);
    // Red fill up to the thumb so the bar reads as a draggable control.
    m.sliderEl.style.background = `linear-gradient(to right, #e8112d ${pos * 100}%, #e9e9e9 ${pos * 100}%)`;
    if (m.tooltipEl) {
      m.tooltipEl.textContent = `${displayVal(cm)} ${unit}`;
      // Center the bubble on the thumb (thumb is ~30px wide).
      m.tooltipEl.style.left = `calc(${pos * 100}% + ${(0.5 - pos) * 30}px)`;
    }
  }

  function buildScale(m) {
    // v2 design: tick labels are replaced by clean min/max labels under the track.
    const minLabel = document.querySelector(`[data-range-min="${m.sliderEl.id}"]`);
    const maxLabel = document.querySelector(`[data-range-max="${m.sliderEl.id}"]`);
    if (minLabel) minLabel.textContent = `${displayVal(parseFloat(m.sliderEl.min))} ${unit}`;
    if (maxLabel) maxLabel.textContent = `${displayVal(parseFloat(m.sliderEl.max))} ${unit}`;
  }

  function syncNum(m) {
    if (m.numEl) m.numEl.value = displayVal(parseFloat(m.sliderEl.value));
  }

  function commit(m) {
    const cm = Math.round(parseFloat(m.sliderEl.value) * 10) / 10;
    formValues[m.formKey] = `${cm} cm`;
    setTooltip(m);
    syncNum(m);
  }

  function applyUnitToNum(m) {
    if (!m.numEl) return;
    const min = parseFloat(m.sliderEl.min);
    const max = parseFloat(m.sliderEl.max);
    if (unit === 'in') {
      m.numEl.min = cmToIn(min); m.numEl.max = cmToIn(max); m.numEl.step = 0.05;
    } else {
      m.numEl.min = min; m.numEl.max = max; m.numEl.step = 0.1;
    }
  }

  function refreshAll() {
    document.querySelectorAll('.fit-unit-btn').forEach((b) => {
      b.classList.toggle('on', b.dataset.unit === unit);
    });
    measures.forEach((m) => { applyUnitToNum(m); buildScale(m); setTooltip(m); syncNum(m); });
  }

  measures.forEach((m) => {
    m.sliderEl.addEventListener('input', () => commit(m));

    if (m.numEl) {
      m.numEl.addEventListener('change', () => {
        let v = parseFloat(m.numEl.value);
        if (isNaN(v)) { syncNum(m); return; }
        let cm = unit === 'in' ? inToCm(v) : v;
        cm = Math.min(parseFloat(m.sliderEl.max), Math.max(parseFloat(m.sliderEl.min), cm));
        m.sliderEl.value = cm;
        commit(m);
      });
    }
  });

  document.querySelectorAll('.fit-unit-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.dataset.unit === unit) return;
      unit = btn.dataset.unit === 'in' ? 'in' : 'cm';
      localStorage.setItem('fit_unit', unit);
      refreshAll();
    });
  });

  refreshAll();
  measures.forEach((m) => commit(m));
});




// hadle next step 

document.addEventListener("DOMContentLoaded", async function () {
  await getTranslations();
  let steps = document.querySelectorAll(".step"); // All question steps
  let currentStep = 1; // Starting with the first step

  // Initially show the "Find my fit" section and the start button
  if(document.getElementById("initial-fit-section")) {
    document.getElementById("initial-fit-section").style.display = "block";
  }
  if(document.getElementById("startButton")) {
    document.getElementById("startButton").style.display = "block"; 
  

      // When the "Start" button is clicked
      document.getElementById("startButton").addEventListener("click", function () {
          // Hide the initial fit section and start button
        if(document.getElementById("initial-fit-section")) {
          document.getElementById("initial-fit-section").style.display = "none";
        }
          this.style.display = "none"; // Hide the start button
    
          // Show the first step in the quiz
          steps[0].style.display = "block"; 
      });
    }

  // Cache per foot length: the previous version re-validated the same value on
  // every "next" click (7 identical API calls per session).
  let sizeCache = { len: null, res: null };

  async function getSneakerSize(footLength) {
    if (sizeCache.len === footLength && sizeCache.res) { return sizeCache.res; }
    try {
      let langVal = document.getElementById("shopify_locale")?.value || "en";

        const response = await fetch(`https://lake-fitfinder-22a6c251cc65.herokuapp.com/public/api/validate-sneaker-size?foot_length=${footLength}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": langVal
            },
        });

        // Check if the response is OK
        if (!response.ok) {
            // Parse the error response body
            const errorData = await response.json();
              return {
                status: false,
                message: errorData.message,
                data: null,
            };
        }

        // Parse the successful response body
        const data = await response.json();

        // Store the relevant data in localStorage
        localStorage.setItem("sneakerSizeSelected", data.data.final);
        localStorage.setItem("sneakerSizeAllowed", data.data.allowed);

        // Return both message and data
        const result = {
            status: true,
            message: data.message,
            data: data.data,
        };
        sizeCache = { len: footLength, res: result };
        return result;
    } catch (error) {
        return {
            status: false,
            message: error.message,
            data: null,
        };
    }
}

  async function getTranslations() {
    try {
      let langVal = document.getElementById("shopify_locale")?.value || "en";
                 
        const response = await fetch(`https://lake-fitfinder-22a6c251cc65.herokuapp.com/public/api/get-translations`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": langVal
            },
        });

        // Check if the response is OK
        if (!response.ok) {
            // Parse the error response body
            return false;
        }

        // Parse the successful response body
        const data = await response.json();

        localStorage.setItem("errorMessages", JSON.stringify(data.errorMessages));

        // Return both message and data
        return true;
    } catch (error) {
        return false;
    }
}

 $(document).ready(function() {
   
     let langVal = $("#shopify_locale").val() || "en"; 
     if (localStorage.getItem('responseData')) {
         let viewYourFit = 'View your perfect fit';
         if(langVal == 'de') {
           viewYourFit = 'Sehen Sie sich Ihre perfekte Passform an';
         } else if(langVal == 'nl') {
           viewYourFit = 'Bekijk jouw perfecte pasvorm';
         }
         $(".fixed-view-your-fit").show();
         $(".fit-banner__message").text(viewYourFit);
      } else {
       let overfoundtext = 'Over 80% found their perfect fit using our size tool';
         if(langVal == 'de') {
           overfoundtext = 'Über 80 % haben mit unserem Größen-Tool ihre perfekte Passform gefunden';
         } else if(langVal == 'nl') {
           overfoundtext = 'Meer dan 80% vond de perfecte pasvorm met behulp van onze maattool';
         }
       
         $(".fixed-view-your-fit").hide();
         $(".fit-banner__message").text(overfoundtext); 
      }
   
   
    $(document).on('click', 'a[href="/pages/find-my-fit"]', function(event) {
        event.preventDefault();   // Prevent the default link behavior

        if (localStorage.getItem('responseData')) {
            let langVal = $("#shopify_locale").val() || "en";
            //const redirectUrl = langVal !== "en" ? `/${langVal}/collections/all-products` : "/collections/all-products?sort_by=manual";
            let redirectUrl = "/collections/all-products?sort_by=manual";
            // Use setTimeout to ensure the redirect happens smoothly
            setTimeout(function() {
                window.location.href = redirectUrl;
            }, 100);
        } else {
          let redirectUrl = "/pages/find-my-fit";
            console.log("No responseData in localStorage. Continue as usual.");
            //window.location.href = "/pages/find-my-fit";
          let langVal = $("#shopify_locale").val() || "en";
          // redirectUrl = langVal !== "en" ? `/${langVal}/pages/find-my-fit` : "/pages/find-my-fit";

          window.location.href = redirectUrl;
        }
    });

   $(document).on('click', '#resetResultPage', function () {
     
      setTimeout(function() {
         localStorage.removeItem('responseData');
         //window.location.href = "/pages/find-my-fit";
        let langVal = $("#shopify_locale").val() || "en";
        let redirectUrl = "/pages/find-my-fit";
        //redirectUrl = langVal !== "en" ? `/${langVal}/pages/find-my-fit` : "/pages/find-my-fit";
        
         window.location.href = redirectUrl;
      }, 100);
   })
});

  
  // Handle the "Next step" button click
  $(document).ready(function () {

    
    
  $(".nextStepButton").on("click", async function () {
    console.log(formValues);

    let nextStep = parseInt($(this).data("next-step"));
    const footWidth = formValues.foot_width ? parseFloat(formValues.foot_width) : 0;
    const footLength = formValues.foot_length ? parseFloat(formValues.foot_length) : 0;
    const sizeResponse = await getSneakerSize(footLength);
    let errorMessages = JSON.parse(localStorage.getItem("errorMessages"));

    console.log("errorMessages", errorMessages);
    console.log("footWidth", footWidth);
    console.log("footLength", footLength);
    console.log("nextStep", nextStep);

    clearStepErrors();

    // Validate form values for each step (inline feedback, no alert popups)
    if (nextStep === 4 && (!formValues.sneaker_size || formValues.sneaker_size === "")) {
      showStepError(errorMessages.select_sneaker_size);
      return;
    } else if (nextStep === 5 && (!formValues.instep_size || formValues.instep_size === "")) {
      showStepError(errorMessages.select_sneaker_instep);
      return;
    } else if (nextStep === 6 && (!formValues.arch_size || formValues.arch_size === "")) {
      showStepError(errorMessages.select_sneaker_arch);
      return;
    } else if (nextStep === 7 && (!formValues.hallux || formValues.hallux === "")) {
      showStepError(errorMessages.select_sneaker_hallux);
      return;
    }

    if (nextStep === 2 && sizeResponse.status === false) {
      showStepError(sizeResponse.message);
      return;
    }

    if (nextStep === 3) {
      // Single source of truth: the recommended size ("final") is the limit.
      // Previously the limit used "allowed" while the recommendation showed
      // "final", so picking the tool's own advice triggered an error.
      const sneakerSizeRecommend = parseFloat(localStorage.getItem("sneakerSizeSelected"));
      const sneakerSizeVal = localStorage.getItem("sneakerSizeAllowed");

      $(".number-grid.shoes_size_class li").each(function () {
        const sizeValue = parseFloat($(this).text().trim().replace(",", "."));
        $(this).removeAttr("data-title");
        if (sizeValue > sneakerSizeRecommend) {
          const titleMsg = errorMessages.size_not_avail
            .replace("{43}", sneakerSizeVal)
            .replace("{44}", sneakerSizeRecommend);
          $(this).attr("data-title", titleMsg);
        }
      });

      // Positive guidance up front instead of an error afterwards.
      const langVal = $("#shopify_locale").val() || "en";
      let hint = 'Based on your foot length we recommend size <b>' + sneakerSizeRecommend + '</b> or smaller.';
      if (langVal === 'nl') hint = 'Op basis van je voetlengte adviseren we maat <b>' + sneakerSizeRecommend + '</b> of kleiner.';
      else if (langVal === 'de') hint = 'Basierend auf deiner Fußlänge empfehlen wir Größe <b>' + sneakerSizeRecommend + '</b> oder kleiner.';
      $(".size_hint").html(hint);
    }

    if ($(this).attr("data-next-step").trim() === "show-results") {
      if (!formValues.shoe_type || formValues.shoe_type === "") {
        showStepError(errorMessages.select_shoe_type);
        return;
      }

      // The API expects the Dutch value "Triatlon"; map the corrected
      // English display label back so copy fixes never break matching.
      const postData = Object.assign({}, formValues, {
        shoe_type: formValues.shoe_type === "Triathlon" ? "Triatlon" : formValues.shoe_type
      });
      const langVal = $("#shopify_locale").val() || "en";

      try {
        $('#loader').fadeIn();
        const response = await fetch("https://lake-fitfinder-22a6c251cc65.herokuapp.com/public/api/products-filter-new", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": langVal
          },
          body: JSON.stringify(postData)
        });

        if (!response.ok) {
          const errorData = await response.json();
          $('#loader').fadeOut();
          showStepError(errorData.message);
          return;
        }

        const data = await response.json();
        localStorage.setItem("responseData", JSON.stringify(data.data));
        console.log("Response from server:", data);

        // Reset form elements
        $(".number-grid.shoes_size_class li, .shoes_type li").removeClass("active").css("background-color", "");
        $(".height_instep input[type='radio'], .height_arch input[type='radio'], .radio_yes_no input[type='radio']").prop("checked", false);

        const resetSlider = (slider, tooltip) => {
          const minValue = slider.attr("min");
          slider.val(minValue);
          tooltip.css("left", "0%").text(`${minValue} cm`);
        };

        resetSlider($("#singleSlider2"), $("#singleSliderTooltip2"));
        resetSlider($("#singleSlider"), $("#singleSliderTooltip"));

        formValues = {
          foot_length: "22.7 cm",
          foot_width: "7.5 cm",
          sneaker_size: "",
          instep_size: "",
          arch_size: "",
          hallux: "",
          shoe_type: ""
        };

        //window.location.href = langVal !== "en" ? `/${langVal}/collections/all-products` : "/collections/all-products?sort_by=manual";
        window.location.href = "/collections/all-products?sort_by=manual";
      } catch (error) {
        $('#loader').fadeOut();
        console.error("Error fetching data:", error);
        localStorage.setItem("responseData", "");
      }
    } else {
      $('#loader').fadeOut();
      if (nextStep <= steps.length) {
        $(steps[currentStep - 1]).hide();
        $(steps[nextStep - 1]).show();
        currentStep = nextStep;
      }
    }
  });
});


 $(document).ready(function () {
    let sizeListItems = $(".shoes_size_class li");

    sizeListItems.on("mouseenter", function () {
        if (!$(this).hasClass("active")) {
            $(this).css("background-color", "#C7C7C7"); // Light gray on hover
        }
    });

    sizeListItems.on("mouseleave", function () {
        if (!$(this).hasClass("active")) {
            $(this).css("background-color", ""); // Reset to default when not active
        }
    });

    sizeListItems.on("click", function (e) {
        if ($(this).attr("data-title")) {
            e.preventDefault();
            $(".error_msg").html($(this).attr("data-title"));
            //sizeListItems.removeClass("active").css("background-color", ""); // Reset background color
            //formValues.sneaker_size = "";
            //return;
        } else {
            $(".error_msg").html("");
        }

        sizeListItems.removeClass("active").css("background-color", ""); // Reset background color and remove active class from all items
        $(this).addClass("active"); // Add active class to the clicked item
        formValues.sneaker_size = $(this).text().trim(); // Update sneaker_size in formValues
    });
});

$(document).ready(function () {
  // Handle click on .radio-div to check the corresponding radio button and update formValues
  $('.radio-div').on('click', function () {
    $(this).find("input[type='radio']").prop('checked', true);

    formValues.instep_size = $(".height_instep .radio-div input[type='radio']:checked").val();
    formValues.arch_size = $(".height_arch .radio-div input[type='radio']:checked").val();
    formValues.hallux = $(".radio_yes_no .radio-div input[type='radio']:checked").val();
  });

  // Handle radio button change for height_instep, height_arch, and hallux
  $(".height_instep input[type='radio']").on("change", function () {
    if ($(this).is(":checked")) {
      formValues.instep_size = $(this).val();
    }
  });

  $(".height_arch input[type='radio']").on("change", function () {
    if ($(this).is(":checked")) {
      formValues.arch_size = $(this).val();
    }
  });

  $(".radio_yes_no input[type='radio']").on("change", function () {
    if ($(this).is(":checked")) {
      formValues.hallux = $(this).val();
    }
  });

  // Handle shoe type selection with hover and click functionality
  $(".shoes_type li").on({
    mouseenter: function () {
      if (!$(this).hasClass("active")) {
        $(this).css("background-color", "#C7C7C7"); // Light gray on hover
      }
    },
    mouseleave: function () {
      if (!$(this).hasClass("active")) {
        $(this).css("background-color", ""); // Reset background color
      }
    },
    click: function () {
      console.log("Clicked shoe type:", $(this).text().trim()); // debug line
      $(".shoes_type li").removeClass("active").css("background-color", ""); // Reset all items
      $(this).addClass("active"); // Add active class to clicked item
      formValues.shoe_type = $(this).text().trim(); // Update shoe_type in formValues
      console.log("formValues.shoe_type set to:", formValues.shoe_type); // debug line
    }
  });
});


  // Handle the "Back" button click
  document.querySelectorAll(".back_button").forEach(function (button) {
      button.addEventListener("click", function () {
          let previousStep = currentStep - 1;
          if (previousStep >= 1) {
              // Hide the current step
              steps[currentStep - 1].style.display = "none";
              
              // Show the previous step
              steps[previousStep - 1].style.display = "block";
              currentStep = previousStep; // Update the current step index

          } else {
              // If we're on the first step, go back to the initial page
            if(document.getElementById("initial-fit-section")) {
              document.getElementById("initial-fit-section").style.display = "block";
            }
            if(document.getElementById("startButton")) {
              document.getElementById("startButton").style.display = "block"; 
            }
              steps.forEach(function(step) {
                  step.style.display = "none"; // Hide all steps
              });
          }
      });
  });

});

